import './css/index.css';
import React from 'react';
import { func } from 'prop-types';

const DownloadButton = ( { saveChart } ) => {

    return (
        <div className="download-button png-ref">

            <a onClick={ () => saveChart() } className="download-chart-button" data-testid="chart-download-btn">
                <button id="saveButton" type="button" title="Download PNG" className="download-png share-download circle-icon">PNG</button>
            </a>

        </div>
    );

};

DownloadButton.propTypes = {
    saveChart: func,

};

export default DownloadButton;
